<template>
  <div class="container-fluid">
    <div id="topo" class="card-header">
      <div class="row">
        <div class="col col-xs-2">
          <h4 class="panel-title">
            <span class="title">Consulta Notas Fiscais Rps</span>
            <br />
            <span class="navigation">Notas Fiscais Rps > Consulta</span>
          </h4>
        </div>
      </div><!--row-->
    </div><!--card-header-->

    <div class="card-body">
      <div class="row">
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Calendar id="dataIni" name="dataFim" v-model="dataRecebimentoIni" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Calendar id="dataFim" name="dataFim" v-model="dataRecebimentoFin" :showIcon="true" dateFormat="dd/mm/yy"
              placeholder="Data Final" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <InputText id="numeroLote" name="numeroLote" v-model="numeroLote" placeholder="Número Lote"
              @keyup.enter="pesquisar" />
          </span>
        </div>
        <div class="col-md-3 col-lg-2 mb-3">
          <span class="p-fluid">
            <Button label="Pesquisar" title="Pesquisar" type="button" icon="pi pi-search" :disabled="loading"
              @click="pesquisar()" />
          </span>
        </div>
        <div class="md-2 mb-2">
          <span class="p-fluid">
            <Button label="Processar Novo Lote" title="Processar Novo Lote" type="button" icon="pi pi-check"
              :disabled="loading" @click="processarNovoLote()" />
          </span>
        </div>
      </div>
      <div class="row">
        <DataTable :value="notasRpsList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
          <template #empty>
            <tr class="p-datatable-empty">
              <td>Nenhuma Nota Fiscal RPS encontrada!</td>
            </tr>
          </template>
          <Column header="Visualizar Nota Fiscal" headerStyle="width: 12em" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button
                v-if="!slotProps.data.errosLote && !slotProps.data.errosXsd && !slotProps.data.erros ? true : false"
                type="button" icon="pi pi-search" label="Exibir Notas"
                @click="openWindowNota(slotProps.data.id, slotProps.data.numeroLote)"></Button>
            </template>
          </Column>
          <Column header="Visualizar Erros" headerStyle="width: 12em" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button v-if="slotProps.data.errosLote || slotProps.data.errosXsd || slotProps.data.erros ? true : false"
                type="button" icon="pi pi-file-excel" label="Erros"
                @click="openWindowErrosRps(slotProps.data.errosLote, slotProps.data.errosXsd, slotProps.data.erros)"></Button>
            </template>
          </Column>
          <Column field="numeroLote" header="Número Lote"></Column>
          <Column field="dataRecebFormatada" header="Data Recebimento"></Column>
          <Column field="dataProcesFormatada" header="Data Processamento"></Column>
          <Column field="acaoDescricao" header="Serviço"></Column>
          <Column field="processadoExtenso" header="Processado"></Column>
        </DataTable>
      </div>
      <hr />
      <template>
        <router-link to="/consultaNfse">
          <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
            icon="pi pi-arrow-left"></Button>
        </router-link>
      </template>
    </div>



    <Dialog header="Erro Nota RPS" :contentStyle="{ overflow: 'visible' }" :visible.sync="showErrosRps"
      :style="{ width: '70vw' }" :modal="true">
      <h1 class="titulo-header">
        Erro Nota RPS
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showErrosRps = false" />
      </h1><br />
      <template>
        <p>
          <span style="font-weight: bold">Erro RPS:</span> {{ errosLoteRps }}
        </p>
      </template>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="closeWindowErrosRps()" title="Não"
              class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Processar novo Lote Rps" :visible.sync="showNovoLote" :style="{ width: '40vw' }" :modal="true">
      <h1 class="titulo-header">
        Processar novo Lote Rps
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showNovoLote = false" />
      </h1><br />
      <div class="card-body">
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="file">Selecione o Tipo do Envio: </label>
            <br />
            <Dropdown id="tipo" v-model="selectedTipo" :options="tipos" optionLabel="name"
              placeholder="Selecione um Tipo de Envio" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="file">Anexar abaixo o XML: </label>
            <br />
            <span class="p-fluid">
              <input type="file" id="files" ref="files" v-on:change="handleFileUploads()" />
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Processar" icon="pi pi-check" @click="processarLote()" class="mr-2" />
            <Button label="Fechar" icon="pi pi-times" @click="showNovoLote = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog header="Nota Fiscal Referente ao Lote RPS" :contentStyle="{ overflow: 'visible' }"
      :visible.sync="showTelaNota" :style="{ width: '70vw' }" :modal="true">
      <h1 class="titulo-header">
        Nota Fiscal Referente ao Lote RPS
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showTelaNota = false" />
      </h1><br />
      <div class="row">
        <div class="col-md-3 mb-2">
          <label for="lote" style="font-weight: bold;">Lote:</label>
          <span class="p-fluid">
            <InputText type="text" disabled title="Lote" v-model="showNumeroLote" />
          </span>
        </div>
        <div class="col-md-4 mb-2">
          <label for="protocolo" style="font-weight: bold;">Protocolo:</label>
          <span class="p-fluid">
            <InputText type="text" disabled title="Protocolo" v-model="showProtocolo" />
          </span>
        </div>
      </div>
      <hr />
      <DataTable :value="notasList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true">
        <template #header>
          <div class="table-header" style="text-transform: uppercase; font-weight: bold; text-align: center;">
            Notas Geradas
          </div>
        </template>
        <Column header="Imprimir Nota Fiscal" headerStyle="width: 12em" bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-print" label="Visualizar" @click="visualizar(slotProps.data.id)"></Button>
          </template>
        </Column>
        <Column field="numero" header="Número NFS-e"></Column>
        <Column field="rpsNumero" header="Número RPS"></Column>
        <Column field="rpsSerie" header="Série RPS"></Column>
        <Column field="rpsTipo" header="Tipo RPS"></Column>
        <Column field="dataEmissaoFormatada" header="Data Emissão"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="closeWindowNota()" title="Não" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
  </div><!--container-fluid-->
</template>

<script>
/* eslint-disable */
import LoginService from "../services/acesso/login.service";
import NotaFiscalRpsService from '../services/nfse/notafiscalrps.service';
import NotaFiscalService from '../services/nfse/notafiscal.service';
import ReportService from "../services/report.service";

export default {
  name: 'ConsultaNfseRps',
  data() {
    return {
      loading: false,
      display: false,
      search: false,
      lote: null,
      notasRpsList: [],
      notasList: [],
      currentUser: null,
      dataRecebimentoIni: null,
      dataRecebimentoFin: null,
      showErrosRps: false,
      errosLoteRps: null,
      errosXsdRps: null,
      errosRps: null,
      desabilitaErrosRps: true,
      numeroLote: null,
      showNovoLote: false,
      selectedTipo: null,
      tipos: [
        { name: "EnviarLoteRps", key: "E" },
        { name: "EnviarLoteRpsSincrono", key: "S" },
        { name: "GerarNfse", key: "G" }
      ],
      files: "",
      showTelaNota: false,
      idRps: null,
      showNumeroLote: null,
      showProtocolo: null,
      observacaoClienteNfse: false
    }
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    this.dataRecebimentoIni = new Date();
    this.dataRecebimentoIni.setDate(this.dataRecebimentoIni.getDate() - 30);
    this.dataRecebimentoFin = new Date();
    this.selectedTipo = this.tipos[0];
    this.pesquisar();
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";
  },

  methods: {
    processarNovoLote() {
      this.showNovoLote = true;
      this.files = "";
      this.lote = {};
    },
    handleFileUploads() {
      this.files = this.$refs.files.files;
    },
    processarLote() {
      if (this.files && this.files[0]) {
        this.processando(true);
        this.getBase64(this.files[0]).then(response => {

          let base64 = response.replace("data:", "").replace(/^.+,/, "");
          this.lote.file = base64;

          this.lote.nomeArquivo = this.files[0].name;
          this.lote.tipoArquivo = this.files[0].type;
          this.lote.tipoSelecionado = this.selectedTipo.key;

          NotaFiscalRpsService.processar(this.lote)
            .then(
              (response) => {
                this.lote = response.data;
                let msgProtocolo = ' ';
                if (this.lote && this.lote.protocolo) {
                  msgProtocolo = ' Protocolo: ' + this.lote.protocolo + ' ';
                }
                this.$toast.add({
                  severity: "success",
                  summary: "Sucesso",
                  detail: "Lote" + msgProtocolo + "Registrado com sucesso!"
                });
                this.processando(false);
              },
              (error) => {
                console.log(error.response);
                this.$toast.add({
                  severity: "error",
                  summary: "Erro",
                  detail: error.response.data,
                });
                this.processando(false);
              }
            )
            .then(() => {
              this.pesquisar();
              this.processando(false);
            });
        });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: 'Selecione um arquivo XML válido!'
        });
      }
    },
    pesquisar() {
      this.processando(true);
      let msg = null;

      if (!this.dataRecebimentoIni) {
        msg = "É necessário selecionar uma data de recebimento inicial";
      }

      if (!this.dataRecebimentoFin) {
        msg = "É necessário selecionar uma data de recebimento final";
      }

      if (!msg) {
        this.search = true;
        NotaFiscalRpsService.findAllNotasRps(
          this.currentUser.contribuinte.idUsuarioContr,
          this.currentUser.usuario.idCliente,
          this.dataRecebimentoIni,
          this.dataRecebimentoFin,
          this.numeroLote
        ).then(
          (response) => {
            this.notasRpsList = response;
            this.showNumeroLote = this.notasRpsList.numeroLote;
            console.log(this.notasRpsList);
            console.log(this.notasRpsList.numeroLote);
          },
          error => {
            let errorMessage = "Houve um problema ao listar Notas Fiscais Rps!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          }
        ).then(() => {
          this.processando(false);
        });
        this.search = false;
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    openWindowErrosRps(errosLote, errosXsd, erros) {
      if ((errosLote === null || errosLote === "") && (errosXsd === null || errosXsd === "") && (erros === null || erros === "")) {
        this.errosLoteRps = "Não existe erros para este RPS.";
        this.errosXsdRps = "Não existe erros para este RPS.";
        this.errosRps = "Não existe erros para este RPS.";
        this.showErrosRps = true;
      } else {
        this.errosLoteRps = errosLote;
        this.errosXsdRps = errosXsd;
        this.errosRps = erros;
        console.log(this.errosLoteRps)
        console.log(this.errosRps);
        this.showErrosRps = true;
      }
    },
    closeWindowErrosRps() {
      this.showErrosRps = false;
    },

    openWindowNota(rps, numeroLote) {
      this.idRps = rps;
      this.showNumeroLote = numeroLote;
      this.showProtocolo = this.idRps;
      console.log(this.idRps);
      this.pesquisarNota();
      this.showTelaNota = true;
    },
    closeWindowNota() {
      this.showTelaNota = false;
    },
    pesquisarNota() {
      this.search = true;
      NotaFiscalService.listNotasByRps(
        this.currentUser.usuario.idCliente,
        this.idRps
      ).then(
        (response) => {
          this.notasList = response
        },
        error => {
          let errorMessage = "Houve um problema ao listar Notas Fiscais!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      )
    },
    visualizar(nfseId) {
      this.processando(true);

      let nomeRel = (this.observacaoClienteNfse ? "NotaFiscalEletronicaObs" : "NotaFiscalEletronica");

      ReportService.imprimir(nomeRel, [
        {
          param: "where",
          string: " and nota_fiscal.id = '" + nfseId + "' ",
        }

      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>
